module.exports = __webpack_public_path__ + "static/media/003-snow-8.a57b7ecd.svg";